export const purchaseFeedbackAttachmentPolicy = {
  maxSize: 32 * 1000 * 1000,
  mimeTypes: [
    "image/jpeg",
    "image/png",
    "image/bmp",
    "image/gif",
    "image/webp",
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ],
};

export const reviewAttachmentPolicy = {
  maxSize: 6 * 1024 * 1024,
  mimeTypes: ["image/jpeg", "image/png", "image/gif"],
};
